import { Autocomplete, TextField } from "@mui/material";
import { StateInfo, useListStateInfoQuery } from "features/trading/accounts";

export const getStateLabel = (
  state: Pick<StateInfo, "state_abbreviation" | "state_name">,
) => `${state.state_abbreviation ?? "--"} - ${state.state_name ?? "Unknown"}`;

interface StateSelectProps {
  /** StateInfo id, or null for no state. */
  value: number | null;
  onChange: (stateId: number | null) => void;
  disabled?: boolean;
  label?: string;
}

/** A drop-down of the US states held in StateInfo, by id. */
const StateSelect = ({
  value,
  onChange,
  disabled,
  label = "State",
}: StateSelectProps) => {
  const { data, isLoading } = useListStateInfoQuery({
    pagination: { page: 0, pageSize: 100 },
    sorting: [{ field: "state_name", sort: "asc" }],
  });
  const states = data?.results ?? [];
  const selected = states.find((state) => state.id === value) ?? null;

  return (
    <Autocomplete
      options={states}
      loading={isLoading}
      disabled={disabled}
      getOptionLabel={getStateLabel}
      value={selected}
      onChange={(_event, next) => onChange(next?.id ?? null)}
      isOptionEqualToValue={(option, other) => option.id === other.id}
      renderInput={(params) => (
        <TextField {...params} label={label} size="small" />
      )}
      clearOnEscape
    />
  );
};

export default StateSelect;
